// extracted by mini-css-extract-plugin
export default {"chat_li":"chatItem_chat_li__orAxG","chatRoom":"chatItem_chatRoom__5hfTE"};